<template>
  <header class="iv-header">
    <Row class-name="iv-main-width">
      <Col :span="16" class-name="iv-fs-24 iv-fc-85 iv-header-title iv-flex">
        <span>
          <img src="@/assets/images/index-logo.png" style="height: 44px;"/>
        </span>
      </Col>

    </Row>
  </header>
</template>

<script>
import orgConfig from './config.js'
import infoScroll from './info-scroll'
import Iconfont from '@/components/iconfont'
// import { mapGetters, mapMutations } from 'vuex'
import clickoutside from '@/directives/clickoutside'

export default {
  data () {
    return {
      isNewMsg: false,
      isInformation: false,
      userInfo: {},
      orgList: [],
      photoSrc: ''
    }
  },
  mounted () {
    sessionStorage.setItem('idMap', JSON.stringify({
      'YWX01': 'orgId',
      'YWX03': 'fullId',
      'YWX04': 'legId',
      'YWX06': 'planId',
      'YWX05': 'cultureId'
    }))
    sessionStorage.setItem('nameMap', JSON.stringify({
      'YWX01': 'orgName',
      'YWX03': 'fullName',
      'YWX04': 'legName',
      'YWX06': 'planName',
      'YWX05': 'cultureName'
    }))
  },
  directives: { clickoutside },
  computed: {
    currentRouteName () {
      return this.$route.name
    },
    crumbsList () {
      return this.$store.state.crumbsList
    }
  },
  watch: {
    $route: {
      handler () {
        if (this.$route.path != '/' && this.$route.name != 'login') {
          this.orgList = Object.keys(orgConfig).map(item => {
            return {
              ...orgConfig[item],
              identityType: item
            }
          })
          // console.log(this.orgList)
          if (this.$route.path != '/homePage') {//BOE家事不需要
            // this.getUserInfo()
            // this.getOrgList()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // ...mapMutations([
    //   'SKINLAYOUT',
    //   'ISNEWMESSAGE'
    // ]),
    getOrgList () {
      sessionStorage.setItem('identityType', JSON.stringify([]))
      sessionStorage.setItem('identityOrgs', JSON.stringify([]))
      this.batchGetUrl()
    },
    batchGetUrl () {
      let urls = ['/api-uum/boe/userIdentity/Dj', '/api-uum/boe/userIdentity/Gj', '/api-uum/boe/userIdentity/Tj', '/api-uum/boe/userIdentity/Qx', '/api-uum/boe/userIdentity/Qh']
      for (let i = 0; i < urls.length; i++) {
        this.getSysUrl(urls[i])
      }
    },
    getSysUrl (url) {
      this.$ajax({
        url: url,
        method: 'get',
        data: {}
      }).then(({data}) => {
        if (!data.data) return
        let currentItem = {}
        this.orgList.map(item => {
          if (item.identityType == data.data.identityType) {
            Object.assign(item, {...data.data, show: true})
            currentItem = item
          }
        })
        let types = JSON.parse(sessionStorage.getItem('identityType') || '[]')
        types.push(data.data.identityType)
        let list = JSON.parse(sessionStorage.getItem('identityOrgs') || '[]')
        list.push(currentItem)
        sessionStorage.setItem('identityType', JSON.stringify(types))
        sessionStorage.setItem('identityOrgs', JSON.stringify(list))
      })
    },
    getUserInfo () {
      this.$ajax({
        url: 'api-uum/uuminfo/getUserInfo',
        method: 'get',
        data: {}
      }).then(({data}) => {
        this.userInfo = data.data
        sessionStorage.setItem('userId', this.$encode(this.userInfo.userCode))
        sessionStorage.setItem('userName', this.$encode(this.userInfo.userName))
        sessionStorage.setItem('userCode', this.$encode(this.userInfo.userCode))
        sessionStorage.setItem('userPhone', this.$encode(this.userInfo.mobile))
        sessionStorage.setItem('userEmail', this.$encode(this.userInfo.email || 'www@163.com'))
        sessionStorage.setItem('idCardNum', this.$encode(this.userInfo.idCardNum))
        sessionStorage.setItem('birthday', this.$encode(this.userInfo.birthday))
        sessionStorage.setItem('userGender', this.$encode(this.userInfo.sex))
        sessionStorage.setItem('userPolitical', this.$encode(this.userInfo.polity))
        sessionStorage.setItem('userDutyName', this.$encode(this.userInfo.dutyName))
        sessionStorage.setItem('politicsOrgName', this.$encode(this.userInfo.orgName))
        this.getUserOrganization(this.userInfo.userId, 'YWX01', 'orgId', 'orgName') //党
        this.getUserOrganization(this.userInfo.userId, 'YWX03', 'fullId', 'fullName') //会
        this.getUserOrganization(this.userInfo.userId, 'YWX04', 'legId', 'legName') //团
        this.getUserOrganization(this.userInfo.userId, 'YWX06', 'planId', 'planName') //企划管理
        this.getUserOrganization(this.userInfo.userId, 'YWX05', 'cultureId', 'cultureName') //企业文化
        this.getUserHeaderPhoto()
      })
    },
    getUserOrganization (userId, bizLineCode, id, name) {
      this.$ajax({
        url: 'api-general/module/portal/user/getInfo',
        method: 'get',
        data: {
          userId: userId,
          bizLineCode: bizLineCode
        }
      }).then(({data}) => {
        const info = data.data
        if (!info) return
        sessionStorage.setItem(id, this.$encode(info.orgId))
        // 组织名称改为简称
        sessionStorage.setItem(name, this.$encode(info.shortName || info.orgName))
      })
    },
    //面包屑跳转
    toNextPage (item) {
      if (this.currentRouteName === item.name) return
      this.$router.push({
        name: item.name,
        query: item.query
      })
    },
    onUserClick (name) {},
    //跳转首页
    toIndexPage () {
      this.$router.push('/index')
    },
    onOprateClick () {
      //this.getMessageList()
    },
    setIsNewMsg (type) {
      this.isNewMsg = type
    },
    // 查找是否有新消息
    getNewLists (oList, nList) {
      let isNew = false
      for (let i = 0; i < nList.length; i++) {
        if (!(oList.includes(nList[i]))) {
          isNew = true
          break
        }
      }
      return isNew
    },
    setMessageList () {
      let list = JSON.parse(localStorage.getItem('messageFlashList'))
      if (list && list.length) {
        let isNew = this.getNewLists(list, this.newMessageList)
        if (isNew) {
          localStorage.setItem('messageFlashList', JSON.stringify(this.newMessageList))
          this.isInformation = true
          setTimeout(() => {
            this.isInformation = false
          }, 4500)
        }
        return
      }
      localStorage.setItem('messageFlashList', JSON.stringify(this.newMessageList))
      this.isInformation = true
      setTimeout(() => {
        this.isInformation = false
      }, 4500)
    },
    // 获取未读列表
    getMessageList () {
      this.$ajax({
        url: 'innermessage/unreadNumber/get',
        method: 'GET',
        data: {}
      }).then(({ data }) => {
        if (data.data.count > 0) {
          //this.ISNEWMESSAGE(true)
          this.newMessageNum = data.data.count > 99 ? '99+' : data.data.count
          this.newMessageList = data.data.ids
          this.setMessageList()
        } else {
          //this.ISNEWMESSAGE(false)
          this.newMessageNum = 0
        }
        //开始遍历提示
        setTimeout(() => {
          //this.getMessageList()
        }, this.loopTime)
      })
    },
    // 消息框点击事件
    handleInfoClick (event) {
      this.isInformation = true
    },
    handleClose (e) {
      this.isInformation = false
    },
    //切换类型
    onMenuClick (name) {
      const item = this.orgList.find(val => val.identityType === name)
      if (item) {
        console.log(`${item.systemUrl}#/?access_token=${sessionStorage.getItem('token')}`)
        const url = `${item.systemUrl}#/?access_token=${sessionStorage.getItem('token')}`
        window.open(url)
      }
    },
    //获取头像
    getUserHeaderPhoto () {
      this.$ajax({
        url: 'api-uum/module/portal/user/getPhoto',
        method: 'get',
        data: {
          userCode: this.userInfo.userCode
        },
        responseType: 'arraybuffer'
      }).then((response) => {
        this.photoSrc = `data:image/png;base64,${btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`
      })
    },
    nofind () {
      var img = event.srcElement
      img.src = require('@/assets/images/user/header-3.png')
      img.onerror = null
    }
  },
  components: {
    Iconfont,
    infoScroll
  }
}
</script>

<style lang="scss" scoped>
.iv-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  background-color: #fff;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.09);
  .iv-header-title {
    height: 64px;
  }
  .iv-header-right {
    height: 64px;
    -webkit-box-pack: right;
    -webkit-justify-content: right;
    -ms-flex-pack: right;
    justify-content: flex-end;
    .iv-hader-headImg {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
  .iv-flex {
    display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
    display: -moz-box; /* 老版本语法: Firefox (buggy) */
    display: -ms-flexbox; /* 混合版本语法: IE 10 */
    display: -webkit-flex; /* 新版本语法: Chrome 21+ */
    display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
  @keyframes myFlash {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes myFlash {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .iv-flash {
    animation: myFlash 1s infinite;
    -webkit-animation: myFlash 1s infinite;
  }
  // .iv-bell-badge {
  //   /deep/ .ivu-badge-count {
  //     border: none;
  //     height: 16px;
  //     line-height: 16px;
  //     top: -5px;
  //     min-width: 16px;
  //     padding: 0;
  //   }
  // }
  .info-scroll {
    position: absolute;
    top: 60px;
    right: -38px;
    z-index: 110;
    min-width: 460px;
  }
}
</style>
<style lang="scss">
  .iv-desktop-li {
    dl {
      overflow: hidden;
      .iconfont {
        font-size: 40px;
      }
      p {
        width: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .iv-user-li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    &:last-child {
      border: none;
    }
  }
</style>
